// extracted by mini-css-extract-plugin
module.exports = {"smsConfirm":"style-module--smsConfirm--VB8R_","newPass":"style-module--newPass--2VL8e"};